import { ReactElement, Suspense } from 'react';

import { Outlet } from 'react-router-dom';

import MetaTags from '@/components/meta/MetaTags';

import useAppStyles from '@/hooks/useAppStyles';
import useInitializeApp from '@/hooks/useInitializeApp';

import ConfigProviderWrapper from './config-provider-wrapper';

import { Loader } from '@/components';
import { FlowsControllerProvider } from '@/context/flows-controller/FlowsControllerProvider';
import { PartnerDto } from '@/generated-types';

const AppLayout = (): ReactElement => {
	const { isLoading, partnerData } = useInitializeApp();

	useAppStyles();

	return (
		<ConfigProviderWrapper>
			<MetaTags partner={partnerData as Required<PartnerDto>} />
			{isLoading ? (
				<Loader absolute />
			) : (
				<Suspense fallback={<Loader absolute />}>
					<FlowsControllerProvider>
						<Outlet />
					</FlowsControllerProvider>
				</Suspense>
			)}
		</ConfigProviderWrapper>
	);
};

export default AppLayout;
